export default function Header(props) {
    return (
        <div className="flex items-center h-32 bg-[#054852] shadow-lg">
            <h1 className="ml-10 text-3xl font-bold text-white">{props.title}</h1>
        </div>
    )
}